var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93806 0.5H4.06907C1.51977 0.5 0 2.01977 0 4.56907V10.4311C0 12.9874 1.51977 14.5071 4.06907 14.5071H9.93106C12.4804 14.5071 14.0001 12.9874 14.0001 10.4381V4.56907C14.0071 2.01977 12.4874 0.5 9.93806 0.5Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4384 6.8551H7.64457V4.06124C7.64457 3.70878 7.35229 3.4165 6.99984 3.4165C6.64738 3.4165 6.3551 3.70878 6.3551 4.06124V6.8551H3.56124C3.20878 6.8551 2.9165 7.14738 2.9165 7.49984C2.9165 7.85229 3.20878 8.14457 3.56124 8.14457H6.3551V10.9384C6.3551 11.2909 6.64738 11.5832 6.99984 11.5832C7.35229 11.5832 7.64457 11.2909 7.64457 10.9384V8.14457H10.4384C10.7909 8.14457 11.0832 7.85229 11.0832 7.49984C11.0832 7.14738 10.7909 6.8551 10.4384 6.8551Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSquare);
export default __webpack_public_path__ + "static/media/add-square.4b981420.svg";
export { ForwardRef as ReactComponent };